<template>
    <div>
        <div v-if="path" class="flex items-center mb-5 text-xs pt-10 lg:pt-8 overflow-x-hidden">
            <nuxt-link class="link text-sm font-Inter-Semibold" to="/">{{ $t('products.breadcrumb.home') }}</nuxt-link>
            <nuxt-link
                v-for="(route, i) in processedBreadcrumbItems"
                :key="`path-${i}`"
                class="link whitespace-nowrap lg:whitespace-normal text-sm"
                :to="localePath({ name: route.name, params: route.params })"
                >{{ createBreadcrumbItemLabel(route) }}</nuxt-link
            >
            <nuxt-link
                v-if="categorySlug"
                class="link whitespace-nowrap lg:whitespace-normal text-sm"
                :to="
                    localePath({
                        name: 'products-category',
                        params: { category: categorySlug },
                    })
                "
            >
                {{ categoryName }}
            </nuxt-link>
            <nuxt-link class="link whitespace-nowrap lg:whitespace-normal text-sm" to="/">{{
                currentRoute || currentStaticRoute
            }}</nuxt-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Breadcrumb',
    props: {
        currentStaticRoute: {
            type: String,
            required: false,
            default: '',
        },
        categorySlug: {
            type: String,
            required: false,
            default: '',
        },
        categoryName: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            path: null,
            products: null,
            currentRoute: null,
            processedBreadcrumbItems: [],
        };
    },
    mounted() {
        this.path = this.$route.params;
        /* this.$axios
            .get('/products')
            .then((response) => {
                this.products = response.data.data;

                Object.keys(this.path).forEach((item) => {
                    let category = null;
                    if (item === 'category') {
                        category = this.path[item];
                        this.processedBreadcrumbItems.push({
                            name: 'products-category',
                            params: { category },
                        });
                    } else {
                        this.processedBreadcrumbItems.push({
                            name: 'products-category-product',
                            params: { category: this.$route.params.category, product: this.$route.params[item] },
                        });
                    }
                    console.log(this.processedBreadcrumbItems);
                });
            })
            .catch((err) => {
                console.log(err);
            }); */
    },
    methods: {
        createBreadcrumbItemLabel(route) {
            console.log(route);
            if (route.name === 'pictures-category') {
                console.log(
                    this.products.find((product) => product.related_categories[0].slug === route.params.category)
                );
                return this.products.find((product) => product.related_categories[0].slug === route.params.category)
                    .related_categories[0].name;
            } else {
                return this.products.find((product) => product.slug === route.params.product).name;
            }
        },
    },
};
</script>

<style scoped>
.link {
    &::after {
        content: '/';
        @apply mx-3;
    }
    &:last-of-type {
        @apply opacity-50 pointer-events-none;
        &::after {
            content: none;
        }
    }
}
</style>
